import { useEffect, useState } from 'react';
import * as Tabs from '@radix-ui/react-tabs';
import { OrderFilter } from './OrderFilter/OrderFilter';
import { EmployeesFilter } from './EmployersFilter/EmployeesFilter';
import styles from './UserFilters.module.scss';
import { ApplicationsFilter } from './ApplicationsFilter/ApplicationsFilter';
import { FeedbackFilters } from './FeedbackFilters/FeedbackFilters';
import { IUsersFilters } from '~/utils/types/userFilterTypes';
import { t } from 'i18next';
import CustomTrigger from '~/ui/CustomTrigger/CustomTrigger';
import { LoyaltyFilter } from './LoyaltyFilter/LoyaltyFilter';

interface IUserFiltersProps {
  isUsersLoading: boolean;
  props: any;
  selectedUsers: number[];
  onClick: (value: IUsersFilters) => void;
  setIsStatusUsersModalOpen: () => void;
  setSelectedUsers: ([]) => void;
}

const SORT_STATUS = {
  ORDERS: 'orders',
  USERS: 'users',
  APPLICATIONS: 'applications',
  FEEDBACK: 'feedback',
  LOYALTY: 'loyalty',
};

const UserFilters = ({
  isUsersLoading,
  selectedUsers,
  onClick,
  setIsStatusUsersModalOpen,
  setSelectedUsers,
}: IUserFiltersProps) => {
  const [selectedSort, setSelectedSort] = useState('orders');

  useEffect(() => {
    onClick({});
    setSelectedUsers([]);
  }, [selectedSort]);

  return (
    <div className={styles.userFilters}>
      <Tabs.Root
        value={selectedSort}
        onValueChange={value => setSelectedSort(value)}
        className={styles.tabsRoot}
      >
        <Tabs.List>
          <CustomTrigger
            value={SORT_STATUS.ORDERS}
            title={t('orders')}
            activeTab={selectedSort}
          />
          <CustomTrigger
            value={SORT_STATUS.USERS}
            title={t('employees')}
            activeTab={selectedSort}
          />
          <CustomTrigger
            value={SORT_STATUS.APPLICATIONS}
            title={t('applications')}
            activeTab={selectedSort}
          />
          <CustomTrigger
            value={SORT_STATUS.FEEDBACK}
            title={t('feedback')}
            activeTab={selectedSort}
          />
          <CustomTrigger
            value={SORT_STATUS.LOYALTY}
            title={t('loyalty')}
            activeTab={selectedSort}
          />
        </Tabs.List>
      </Tabs.Root>

      {selectedSort === SORT_STATUS.ORDERS && (
        <OrderFilter
          isUsersLoading={isUsersLoading}
          selectedUsers={selectedUsers}
          setIsStatusUsersModalOpen={setIsStatusUsersModalOpen}
          onClick={onClick}
        />
      )}
      {selectedSort === SORT_STATUS.USERS && (
        <EmployeesFilter
          isUsersLoading={isUsersLoading}
          onClick={onClick}
          selectedUsers={selectedUsers}
          setIsStatusUsersModalOpen={setIsStatusUsersModalOpen}
        />
      )}
      {selectedSort === SORT_STATUS.APPLICATIONS && (
        <ApplicationsFilter
          isUsersLoading={isUsersLoading}
          onClick={onClick}
          selectedUsers={selectedUsers}
          setIsStatusUsersModalOpen={setIsStatusUsersModalOpen}
        />
      )}
      {selectedSort === SORT_STATUS.FEEDBACK && (
        <FeedbackFilters
          isUsersLoading={isUsersLoading}
          onClick={onClick}
          selectedUsers={selectedUsers}
          setIsStatusUsersModalOpen={setIsStatusUsersModalOpen}
        />
      )}
      {selectedSort === SORT_STATUS.LOYALTY && (
        <LoyaltyFilter
          isUsersLoading={isUsersLoading}
          onClick={onClick}
          selectedUsers={selectedUsers}
          setIsStatusUsersModalOpen={setIsStatusUsersModalOpen}
        />
      )}
    </div>
  );
};

export default UserFilters;
